import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, Typography, Tooltip } from '@material-ui/core';
import Card from 'components/Card';
import Loader from 'components/Loader';
import Input from 'components/Input';
import Select from 'components/Select';
import NumericInput from 'components/NumericInput';

import { loadProvisionalReceiptConfig } from '../../../store/thunk';
import { loadProvisionalReceiptProductTables } from 'pages/ProvisionalReceiptProductConfig/store/thunk';

export default function ProvisionalReceipt({ formikProps }) {
  const dispatch = useDispatch();

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { productUuid } = useSelector(state => state.productsSellRegistration);
  const { isLoading } = useSelector(state => state.productsSellRegistration);

  const {
    tables: {
      taxationOriginProducts,
      taxationSituationsProducts
    }
  } = useSelector(state => state.provisionalReceiptProductConfig);

  const { values, errors, handleChange, setFieldValue } = formikProps;

  useEffect(() => {
    dispatch(loadProvisionalReceiptConfig(userId, establishmentId, productUuid));
    dispatch(loadProvisionalReceiptProductTables(userId));
  }, []);

  return(
    <Card title="Configure para emitir NFC-e">
      <Grid container>
        <Grid xs={12}>
          <Loader isLoading={isLoading}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Input
                  name="ncmCode"
                  type="text"
                  label="NCM"
                  value={values?.ncmCode}
                  error={errors?.ncmCode}
                  helperText={errors?.ncmCode}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Tooltip
                  interactive
                  leaveDelay={250}
                  placement="top"
                  title={
                    <a
                      style={{ color: '#FFFFFF', textDecoration: 'none' }}
                      target="_blank"
                      href="https://jumpcar.com.br/tabela-cfop-o-que-e-e-como-aplicar-para-servicos-automotivos/"
                    >
                      <Typography>Link explicativo</Typography>
                    </a>
                  }
                >
                  <div>
                    <Input
                      name="cfopCode"
                      type="number"
                      label="Código CFOP"
                      value={values?.cfopCode}
                      error={errors?.cfopCode}
                      helperText={errors?.cfopCode}
                      onChange={handleChange}
                    />
                  </div>
                </Tooltip>
              </Grid>
              <Grid item xs={12} md={6}>
                <Select
                  name="icmsOriginId"
                  label="Origem ICMS"
                  options={taxationOriginProducts}
                  value={values?.icmsOriginId?.toString()}
                  error={errors?.icmsOriginId}
                  helperText={errors?.icmsOriginId}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <NumericInput
                  name="icmsAliquot"
                  label="Alíquota do ICMS"
                  value={values?.icmsAliquot}
                  error={errors?.icmsAliquot}
                  helperText={errors?.icmsAliquot}
                  onChange={value => setFieldValue("icmsAliquot", value)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Tooltip
                  interactive
                  leaveDelay={250}
                  placement="top"
                  title={
                    <a
                      style={{ color: '#FFFFFF', textDecoration: 'none' }}
                      target="_blank"
                      href="https://jumpcar.com.br/o-que-e-cst-e-como-se-aplica-em-negocios-automotivos"
                    >
                      <Typography>Link explicativo</Typography>
                    </a>
                  }
                >
                  <div>
                    <Select
                      name="icmsCst"
                      label="CST do ICMS"
                      options={taxationSituationsProducts}
                      value={values?.icmsCst?.toString()}
                      error={errors?.icmsCst}
                      helperText={errors?.icmsCst}
                      onChange={handleChange}
                    />
                  </div>
                </Tooltip>
              </Grid>
            </Grid>
          </Loader>
        </Grid>
      </Grid>
    </Card>
  );
}